export enum EInvoiceTvaType {
  Standard = 0,
  Exempt = 1,
  TvaReverseCharge = 2, // Auto liquidation de TVA
  IntraCommunityReverseCharge = 3, // Auto liquidation pour cause de livraison intracommunautaire
  OutsideEuExempt = 4, // Exempté de TVA pour Export hors UE
  OutOfTvaScope = 5, // Hors du périmètre d'application de la TVA
}
